/**
 * What the product calls itself, in one place.
 *
 * The name used to be typed out at each of the half-dozen places it appears —
 * the browser tab, the topbar's fallback, the two marketing panels either side
 * of sign-in — and the domain at two more. That is how "GradeBook", "IB
 * Gradebook" and "gradebook.app" ended up disagreeing with each other and with
 * the hostname the Worker actually serves. Import these instead of retyping,
 * and the next rename is one edit.
 */
export const APP_NAME = 'All Sevens';

/** The hostname the app is served from; see `routes` in `apps/api/wrangler.toml`. */
export const APP_DOMAIN = 'allsevens.app';

/**
 * How a school's own address reads on screen while it is being created.
 *
 * Both sign-up forms already hide the hint until the slug field has something
 * in it, so the empty case does not reach the screen today. It is handled
 * anyway because `allsevens.app/` with nothing after it looks like a
 * truncation rather than a prompt, and the next caller may not guard.
 */
export function schoolUrlLabel(slug: string): string {
  return slug ? `${APP_DOMAIN}/${slug}` : APP_DOMAIN;
}
